import { componentPermissions } from 'config/permissions'
import { componentNames } from 'config/roles'
import { FC } from 'react'
import { RoutePaths } from 'routes/paths'
import { ContentBody } from 'components/pages/components/ContentBody'
import { IAccordionData, DynamicAccordion } from './components/DynamicAccordion'
import { ElectronicsDocumentData } from './Data/ElectronicsDocumentData'

const ElectronicsDocument: FC = () => {
  return (
      <ContentBody title="knowledgeHub.electronics">
        {ElectronicsDocumentData.map((d: IAccordionData, key: number) => (
          <DynamicAccordion data={d} index={key} key={key} />
        ))}
      </ContentBody>
  )
}

const exportObj = {
  routeProps: {
    // This gets passed straight to react-router
    path: RoutePaths.knowledgeHubElectronics,
    title: 'knowledgeHub.electronics',
    element: <ElectronicsDocument />,
    roles: componentPermissions[componentNames.pageKnowledgeHubDatabaseOverview],
    requiresAuthentication: true,
  },
  name: 'Electronics',
}
export default exportObj
